/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'sysque-context-menu',
  templateUrl: './sysque-context-menu.component.html',
  styleUrls: ['./sysque-context-menu.component.scss'],
  standalone: false
})
export class SysQueContextMenuComponent {
  @Input() menuItems: any[];
  @Output() contextMenuItemSelected = new EventEmitter<string>();
  @Output() contextMenuOpened = new EventEmitter<SysQueContextMenuComponent>();

  public isContextMenuVisible = false;

  public contextMenuVisibility(event: MouseEvent): void {
    event.stopPropagation();

    if (this.isContextMenuVisible) {
      this.hideContextMenu();
    } else {
      this.contextMenuOpened.emit(this);
      this.isContextMenuVisible = true;
      document.addEventListener('click', this.hideContextMenu.bind(this));
    }
  }

  public hideContextMenu(): void {
    this.isContextMenuVisible = false;

    document.removeEventListener('click', this.hideContextMenu.bind(this));
  }

  public emitEvent(event: string): void {
    this.contextMenuItemSelected.emit(event);
    this.hideContextMenu();
  }
}
